import React, { useEffect, useState } from "react";
import validator from "validator";
import axios from "axios";
import { useForm } from "../../../../../hooks/useForm";
import Swal from "sweetalert2";
import Select, { components } from "react-select";
import { firePixels } from "../../../utils/pixelFiring";

export const Form = ({ id, vehiculo, modelYear, handleOpen, pixelTags }) => {
    //selectCustom
    const CustomOption = props => {
        const { data, innerRef, innerProps } = props;
        return data.custom ? (
            <div ref={innerRef} {...innerProps}>
                I'm a custom link
            </div>
        ) : (
            <components.Option {...props} />
        );
    };

    const colourStyles = {
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            const color = "#000000";
            return {
                ...styles,
                backgroundColor: isDisabled
                    ? null
                    : isSelected
                    ? data.color
                    : isFocused
                    ? color
                    : null,
                color: isDisabled
                    ? "#ccc"
                    : isSelected
                    ? "#D1D1D1"
                    : data.color,
                cursor: isDisabled ? "not-allowed" : "default",

                ":active": {
                    ...styles[":active"],
                    backgroundColor:
                        !isDisabled && (isSelected ? data.color : color)
                }
            };
        }
    };

    const [selectedValueConcesionaria, setSelectedValue] = useState("");

    // handle onChange event of the dropdown
    const handleChange = e => {
        setSelectedValue(e.value);
    };

    //data almacena la info total de provincias, localidades y concesionarias para extraer posteriormente.
    const [data, setdata] = useState([]);


    //inicialización de variables
    let provincias = [];
    let localidades = [];
    let concesionarias = [];

    // useForm Hook procesa el input change y setea los valores.
    const [formValues, handleInputChange, reset] = useForm({
        nombre: "",
        dni: "",
        telefono: "",
        email: "",
        provincia: "",
        localidad: ""
    });

    // message se setea si hay un error en la validación del form en la func isFormValid()
    const [message, setMessage] = useState([]);

    //enviado se pasa a true cuando se pasa las validaciones y se maneja el handleLogin, al pegarle a el endpoint y este tiene exito y entra en el then.
    const [enviado, setenviado] = useState(false);

    //loading es false y se setea true cuando se maneja el handleLogin y cuando retorna un resultado ya sea exito o error vuelve a false, en true dispara un alert loading swal
    const [loading, setloading] = useState(false);

    //este es el checkbox de politicas de privacidad si no se setea en true no deja continuar al usuario
    const [checkbox, setcheckbox] = useState(false);

    //valores extraidos de formValues
    let { nombre, dni, telefono, email, provincia, localidad } = formValues;

    // si el usuario cambia la provincia se reinician los valores de localidad y concesionaria
    useEffect(() => {
        formValues.localidad = "";
        if (selectedValueConcesionaria != "") {
            setSelectedValue("");
        }
    }, [provincia]);

    //funciones que manejan el focus del form
    const handleFocus = () => {
        setfocus(true);
    };

    const handleFocusOut = () => {
        setfocus(false);
    };

    //peticion para traer la info de webdac
    useEffect(() => {
        axios({
            // esto viene del back
            url: "/getConcesionarias"
        }).then(response => {
            // seteo de data
            setdata(response.data);
        });


        //cambios del checkbox
        document.querySelector("#cbox").addEventListener("change", function() {
            if (this.checked) {
                setcheckbox(true);
            } else {
                setcheckbox(false);
            }
        });
    }, []);

    data.forEach(dt => {
        let pr = provincias.indexOf(dt.provincia);
        if (pr == -1) {
            provincias.push(dt.provincia);
        }
    });

    let optionsProvincias = [];
    if (provincias.length != 0) {
        provincias.forEach(prov =>
            optionsProvincias.push(
                <option key={prov} value={prov}>
                    {prov}
                </option>
            )
        );
    }

    if (provincia != "") {
        data.forEach(dt => {
            let lc = localidades.indexOf(dt.ciudad);

            if (dt.provincia == provincia) {
                lc == -1 && dt.ciudad != null && localidades.push(dt.ciudad);
            }
        });
    }

    let optionsLocalidades = [];
    if (localidades.length != 0) {
        localidades.forEach(loc =>
            optionsLocalidades.push(
                <option key={loc} value={loc}>
                    {loc}
                </option>
            )
        );
    }

    if (localidad != "") {
        data.forEach(dt => {
            if (dt.ciudad == localidad) {
                concesionarias.push({
                    id: dt.sediId,
                    nombre: dt.nombre,
                    direccion: dt.address
                });
            }
        });
    }

    let optionsConcesionarias = [
        { value: "", label: "Elige una concesionaria" }
    ];

    if (concesionarias.length != 0) {
        concesionarias.forEach(concesionaria =>
            optionsConcesionarias.push({
                value: concesionaria.id,
                label:
                    concesionaria.nombre +
                    " " +
                    "-" +
                    " " +
                    concesionaria.direccion
            })
        );
    }

    // func que valida si los datos ingresados por el usuario son validos
    const isFormValid = () => {
        const regex = /^[0-9]*$/;
        const onlyNumbers = regex.test(dni);

        if (nombre.length < 2) {
            setMessage("Debe completar el nombre");
            return false;
        } else if (dni.length < 7 || dni.length > 8) {
            setMessage("Debe completar correctamente el DNI");
            return false;
        } else if (!onlyNumbers) {
            setMessage("El DNI debe contener solo números");
            return false;
        } else if (!validator.isInt(telefono)) {
            setMessage("Teléfono invalido");
            return false;
        } else if (!validator.isEmail(email)) {
            setMessage("Email invalido");
            return false;
        } else if (validator.isEmpty(provincia)) {
            setMessage("Seleccione una provincia");
            return false;
        } else if (validator.isEmpty(localidad)) {
            setMessage("Seleccione una localidad");
            return false;
        } else if (validator.isEmpty(selectedValueConcesionaria)) {
            setMessage("Seleccione una concesionaria");
            return false;
        } else if (checkbox != true) {
            setMessage("Debe aceptar las condiciones");
            return false;
        }

        setMessage("");
        return true;
    };

    //aca se evalua si loading es true y se dispara el alert
    if (loading == true) {
        Swal.fire({
            title: "Por favor espere",
            html: "cargando...",
            allowOutsideClick: false,
            showCancelButton: false,
            showConfirmButton: false,
            customClass: {
                loader: "colorSwal"
            },
            onBeforeOpen: () => {
                Swal.showLoading();
            }
        });
    }

    //manejo del envio del form
    const handleLogin = e => {
        e.preventDefault();
        // si es valido se envia la info
        if (isFormValid()) {
            // se setea loading a true
            setloading(true);

            let dataEnv = {
                cpf: dni,
                firstName: nombre,
                phone: telefono,
                email: email,
                dealersCode: String(selectedValueConcesionaria || ""),
                productCode: String(id || ""),
                msc_ano_modelo: modelYear ? String(modelYear) : ""
            };

            axios({
                method: "post",
                url: "/api/submit_lead",
                data: dataEnv
            })
                .then(function(response) {
                    console.log(dataEnv);

                    // acá da un resultado se setea loading en false
                    setloading(false);
                    // si el pedido es exitoso se reinicia el form, message se vacia y enviado se pone en true
                    reset();
                    setenviado(true);
                    setMessage("");
                    firePixels(pixelTags, 'form_complete');
                    // si el pedido es exitoso se cierra la alerta de cargando y se dispara el enviado
                    Swal.close();
                    Swal.fire({
                        title: "Enviado",
                        text: "Tus datos fueron enviados con exito!",
                        icon: "success",
                        timer: 2000,
                        confirmButtonText: "Cerrar",
                        customClass: {
                            confirmButton: "confirmButtonSwal"
                        }
                    });
                })
                .catch(function(error) {
                    console.log(dataEnv);
                    // acá termina de procesar se seta loading en false y se cierra la alerta de cargando  y se dipara la alerta de error
                    setloading(false);
                    Swal.close();
                    Swal.fire({
                        title: "Error!",
                        text: "Por favor intenta nuevamente",
                        icon: "error",
                        confirmButtonText: "Cerrar",
                        customClass: {
                            confirmButton: "confirmButtonSwal"
                        }
                    });
                });
        }
    };
    return (
        <div className="formContainer">
            <div className="formContainer--title">
                <h1 className="title20">MÁS INFORMACIÓN</h1>
                <p>
                    Encontrá asesoramiento para alcanzar tu {vehiculo} 0KM con
                    LEAPMOTOR® Plan
                </p>
            </div>

            <form
                className="form"
                onSubmit={handleLogin}
                onFocus={handleFocus}
                onBlur={handleFocusOut}
            >
                <div className="inputs">
                    <div className="inputs--column">
                        <input
                            type="text"
                            placeholder="Nombre y Apellido"
                            name="nombre"
                            autoComplete="off"
                            value={nombre}
                            onChange={handleInputChange}
                        />

                        <input
                            type="text"
                            placeholder="DNI"
                            name="dni"
                            autoComplete="off"
                            value={dni}
                            onChange={handleInputChange}
                            maxLength="8"
                        />

                        <input
                            type="number"
                            placeholder="Teléfono"
                            name="telefono"
                            autoComplete="off"
                            value={telefono}
                            onChange={handleInputChange}
                        />

                        <input
                            type="text"
                            placeholder="Email"
                            name="email"
                            autoComplete="off"
                            value={email}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="inputs--column">
                        <select
                            name="provincia"
                            value={provincia}
                            type="text"
                            onChange={handleInputChange}
                        >
                            <option value="">Elige una provincia</option>
                            {optionsProvincias}
                        </select>

                        <select
                            name="localidad"
                            value={localidad}
                            type="text"
                            onChange={handleInputChange}
                        >
                            <option value="">Elige una localidad</option>
                            {optionsLocalidades}
                        </select>

                        <Select
                            value={optionsConcesionarias.find(
                                obj => obj.value === selectedValueConcesionaria
                            )}
                            components={{ Option: CustomOption }}
                            options={optionsConcesionarias}
                            style={colourStyles}
                            placeholder={<div>Elige una concesionaria</div>}
                            onChange={handleChange}
                        />

                        <div className="checkboxInput">
                            <label className="content-input">
                                <input
                                    type="checkbox"
                                    name="Vehiculo"
                                    id="cbox"
                                    value="checkbox"
                                />
                                <i></i>
                            </label>
                            <div className="text">
                                He leído y acepto la{" "}
                                <a onClick={handleOpen}>
                                    Política de Privacidad
                                </a>
                            </div>
                        </div>

                        {message != "" ? (
                            <p className="text-danger m-0">{message}</p>
                        ) : (
                            enviado && (
                                <p className="text-success m-0">
                                    Tu consulta ha sido enviada
                                </p>
                            )
                        )}
                    </div>
                </div>
                <button
                    className="btn-form mt-half"
                    disabled={enviado}
                    type="submit"
                >
                    Enviar
                </button>
            </form>
        </div>
    );
};
